module.exports = __webpack_public_path__ + "media/images/caret-right-26f7f980bcf605872fd06e22eaaee7e4.svg";